import React, { useState } from "react";
import {
  menuUrl,
  tableTitle,
  keyColumn,
  tableColumn,
  breadCrumbs,
  filters as rawFilters,
  // additionalActions,
} from "@screens/inventory/inventory-category/inventory-category-list/model/category-list.constants";
import { getFilterData } from "@utils/common";
import {
  constructFilterDataAndGetQueryString,
  getFilterQueryString,
  getParamsData,
} from "@utils/filters.util";
import { APP } from "@constants/app.constants";
import { useHistory } from "react-router-dom";
import { checkMenuAccess } from "@utils/menu-auth";

import MESSAGES from "@constants/messages.constants";
import { useDispatch, useSelector } from "react-redux";
import { setAlertMessage } from "@reducers/alert.reducer";
import { deleteDataApi,getDataApi } from "./category-list.component.service";
import InventoryCategoryListTemplateComponent from "./category-list-template.component";

const {
  ALERT_TYPES: { SUCCESS, ERROR },
  CATEGORY_ALERTS: { DELETE_ALERT },
} = MESSAGES;
const { ROWS_PER_PAGE } = APP;

const InventoryCategoryListComponent = () => {
  const { filterList } = useSelector((state) => state.filter);
  const [tableData, setTableData] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const history = useHistory();
  const dispatch = useDispatch();
  const filters = getFilterData(filterList, menuUrl, "filter");
  const menuAccess = checkMenuAccess(menuUrl, "read");
  const tableParams = getParamsData(filterList, menuUrl);
  const { appRowsPerPage } = useSelector((state) => state.app);

  const getCategoryData = async (params = null) => {
    console.log({ params });
    const queryStr = getFilterQueryString(menuUrl, params);
    console.log("queryStr:", queryStr);
    const categoryData = await getDataApi({
      ...params,
      filters: queryStr,
    });
    if (categoryData.status) {
      console.log(categoryData);
      setTableData(categoryData.data);
      setTotalCount(categoryData.totalCount);
    }
  };

  const handleCreateClick = () => {
    history.push(`/${menuUrl}/create`);
  };

  const deleteRecords = async (selected) => {
    const deleteAccess = checkMenuAccess(menuUrl, "delete");
    if (deleteAccess) {
      const response = await deleteDataApi(selected);
      if (response.status) {
        dispatch(
          setAlertMessage({ type: SUCCESS, message: DELETE_ALERT, viewed: 0 })
        );
        getCategoryData({
          orderBy: "created_at",
          sortBy: "desc",
          skip: 0,
          limit: appRowsPerPage || ROWS_PER_PAGE,
        });
      } else {
        dispatch(
          setAlertMessage({ type: ERROR, message: response.message, viewed: 0 })
        );
      }
    } else
      dispatch(
        setAlertMessage({
          type: ERROR,
          message: "Permission denied to delete",
          viewed: 0,
        })
      );
  };

  const submitFilter = (filters) => {
    const queryStr = constructFilterDataAndGetQueryString(filters, menuUrl);
    console.log({ queryStr });
    getCategoryData({
      orderBy: "created_at",
      sortBy: "desc",
      skip: 0,
      limit: appRowsPerPage || ROWS_PER_PAGE,
      filters: queryStr,
    });
  };

  // const handleViewDetail = (row) => {
  //   console.log({ row });
  //   history.push(`/version/bug-list?versionId=${row.id}&title=${row.title}`);
  // };

  return menuAccess ? (
    <InventoryCategoryListTemplateComponent
      templateModal={{
        tableTitle,
        keyColumn,
        breadCrumbs,
        tableColumn,
        tableData,
        totalCount,
        filters: filters ? filters : rawFilters,
        tableParams,
        // tableActions: additionalActions({
        //   // handleViewDetail,
        // }),
      }}
      templateEvents={{
        getCategoryData,
        handleCreateClick,
        deleteRecords,
        submitFilter,
      }}
    />
  ) : (
    <> </>
  );
};

export default InventoryCategoryListComponent;
